<template>
  <div
    class="document-type-card"
    :class="{ 'selected': selected }"
    role="button"
    :aria-label="`Seleccionar documento tipo ${type.text}`"
    :aria-pressed="selected"
    tabindex="0"
    @click="$emit('click')"
    @keydown.enter="$emit('click')"
  >
    <div class="card-icon">{{ icon }}</div>
    <div class="card-title">{{ type.text }}</div>
    <div class="card-code">({{ type.value }})</div>
    <div class="card-description">{{ description }}</div>
    <div v-if="selected" class="selected-indicator">
      <feather-icon icon="CheckCircleIcon" size="24" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentTypeCard',
  props: {
    type: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      const icons = {
        // GORE Valparaíso
        'OF': '📄',
        'MEMO': '📝',
        'SP': '📋',
        'RES': '📑',
        'BIT': '🚗',
        'ACUCORE': '✅',
        'OFCORE': '📄',
        'ODP': '💰',
        'RESUGDPS': '📑',
        'SCP': '✈️',
        'INF': '📊',
        'SOGR': '💵',
        'SEGR': '🏢',
        'IDPC': '📈',
        // Universidad de Aysén
        'SCH': '📝',
        'GRC': '✅',
        'CPSH': '📄',
        'FISABS': '📋',
        'ACT': '📊',
        // SISS
        'AF': '🔍',
        // Aguas Andinas
        'ADP': '⏰',
        'SV': '📨'
      };
      return icons[this.type.value] || '📄';
    },
    
    description() {
      const descriptions = {
        // GORE Valparaíso
        'OF': 'Comunicación oficial externa',
        'MEMO': 'Comunicación interna formal',
        'SP': 'Solicitud de recursos presupuestarios',
        'RES': 'Resolución administrativa',
        'BIT': 'Bitácora de vehículos fiscales',
        'ACUCORE': 'Acuerdos del Consejo Regional',
        'OFCORE': 'Oficio del Consejo Regional',
        'ODP': 'Orden de pago con cargo a gasto de representación',
        'RESUGDPS': 'Resolución de la Unidad de Gestión',
        'SCP': 'Solicitud de pasajes para comisión',
        'INF': 'Informe de uso y custodia de vehículos',
        'SOGR': 'Solicitud de gasto de representación',
        'SEGR': 'Selección de proveedor para gasto',
        'IDPC': 'Informe de desempeño y calificaciones',
        // Universidad de Aysén
        'SCH': 'Solicitud de convenio a honorarios',
        'GRC': 'Guía de recepción conforme',
        'CPSH': 'Convenio de prestación de servicios',
        'FISABS': 'Formulario de adquisición de bienes/servicios',
        'ACT': 'Informe de actividades realizadas',
        // SISS
        'AF': 'Acta de proceso de fiscalización',
        // Aguas Andinas
        'ADP': 'Solicitud de aumento de plazo',
        'SV': 'Solicitudes diversas'
      };
      return descriptions[this.type.value] || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.document-type-card {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  background: white;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  &:hover {
    border-color: #7367f0;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.15);
    transform: translateY(-2px);
  }
  
  &:focus {
    outline: 2px solid #7367f0;
    outline-offset: 2px;
  }
  
  &.selected {
    border-color: #7367f0;
    background-color: #f8f7ff;
    box-shadow: 0 4px 12px rgba(115, 103, 240, 0.25);
  }
  
  .card-icon {
    font-size: 3rem;
    text-align: center;
    margin-bottom: 1rem;
  }
  
  .card-title {
    font-weight: 600;
    font-size: 1.1rem;
    text-align: center;
    margin-bottom: 0.25rem;
    color: #2c3e50;
  }
  
  .card-code {
    font-size: 0.85rem;
    color: #6c757d;
    text-align: center;
    margin-bottom: 0.5rem;
  }
  
  .card-description {
    font-size: 0.9rem;
    color: #6c757d;
    text-align: center;
    line-height: 1.4;
  }
  
  .selected-indicator {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #7367f0;
  }
}

@media (max-width: 576px) {
  .document-type-card {
    padding: 1rem;
    min-height: 180px;
    
    .card-icon {
      font-size: 2.5rem;
    }
    
    .card-title {
      font-size: 1rem;
    }
    
    .card-description {
      font-size: 0.85rem;
    }
  }
}
</style>
